import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Table, Tag, Card, Input } from "antd";
import { withAppContext } from "../../store/contextStore";
import { list } from "../../api/Apis";
import { showTotal } from "../commonFunctions";
const Search = Input.Search;
class DriverInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      driversLeadsList: [],
      totalDriversLeadsList: [],
      dataLoading: false,
    };
  }

  componentDidMount() {
    if (!this.state.userDetails["recordStatus"]) {
      this.props.history.push("/carrier_app/review");
    }
    this.getDriverLeads();
  }

  getDriverLeads = async () => {
    this.setState({
      dataLoading: true,
    });
    const userDetails = await JSON.parse(localStorage.getItem("userDetails"));
    this.setState({
      userDetails: userDetails,
    });

    let requestUrl =
      window.location.pathname === "/app/driver/done"
        ? "getDriverLeads?onlyDeliveredOrders=true"
        : "getDriverLeads?onlyDeliveredOrders=false";

    list(requestUrl).then((result) => {
      if (result.success) {
        this.setState({
          totalDriversLeadsList: result.data,
          driversLeadsList: result.data.sort((a, b) =>
            a.orderId < b.orderId ? 1 : -1
          ),
          dataLoading: false,
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  };

  searchData = (event) => {
    let searcingValue = event.target.value;
    let totalDriversLeadsList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      totalDriversLeadsList = this.state.totalDriversLeadsList.filter(
        (lead) =>
          (Array.isArray(lead.productOriginDetails)
            ? lead.productOriginDetails[0].locationName
                .toLowerCase()
                .indexOf(searcingValue) > -1
            : lead.productOriginDetails.locationName
                .toLowerCase()
                .indexOf(searcingValue) > -1) ||
          lead.address.toLowerCase().indexOf(searcingValue) > -1
      );
    } else {
      totalDriversLeadsList = this.state.totalDriversLeadsList;
    }
    this.setState({
      driversLeadsList: totalDriversLeadsList,
    });
  };

  render() {
    const { userDetails, driversLeadsList, dataLoading } = this.state;
    const columns = [
      {
        title: <div style={{ color: "gray" }}>Pickup Timings</div>,
        dataIndex: "productOriginDetails",
        key: "productOriginDetails",
        render: (productOriginDetails) => (
          <span>
            <div style={{ color: "black" }}>
              {Array.isArray(productOriginDetails)
                ? productOriginDetails?.[0]?.loadingTimes
                : productOriginDetails?.loadingTimes}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Pickup Location</div>,
        dataIndex: "productOriginDetails",
        key: "productOriginDetails",
        render: (productOriginDetails) => (
          <span>
            <div style={{ color: "black" }}>
              {Array.isArray(productOriginDetails)
                ? productOriginDetails?.[0]?.locationName
                : productOriginDetails?.locationName}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Delivery Timings</div>,
        dataIndex: "deliveryReqTime",
        key: "deliveryReqTime",
        render: (deliveryReqTime) => (
          <span>
            <div style={{ color: "black" }}>{deliveryReqTime}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Delivery Location</div>,
        dataIndex: "address",
        key: "address",
        render: (address) => (
          <span>
            <div style={{ color: "black" }}>{address}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Material Details</div>,
        dataIndex: "productOriginDetails",
        key: "productOriginDetails",
        render: (productOriginDetails) => (
          <span>
            <div style={{ color: "black" }}>
              {Array.isArray(productOriginDetails)
                ? productOriginDetails[0]?.materialsLoaded?.join(", ")
                : productOriginDetails?.materialsLoaded?.join(", ")}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        dataIndex: "orderStatus",
        key: "orderStatus",
        render: (orderStatus) => (
          <span className="status_tag">
            <Tag
              color={
                orderStatus === "I" || orderStatus === "AC"
                  ? "#F2F3F6"
                  : orderStatus === "PS"
                  ? "#F2F3F6"
                  : orderStatus === "PU"
                  ? "#0E4D90"
                  : "#F2F3F6"
              }
              key={orderStatus}
              style={{
                color:
                  orderStatus === "I" || orderStatus === "AC"
                    ? "#FF6C5E"
                    : orderStatus === "PS"
                    ? "#0E4D90"
                    : orderStatus === "PU"
                    ? "#F2F3F6"
                    : "#7B8190",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {orderStatus === "I" || orderStatus === "AC"
                ? "Open"
                : orderStatus === "PS"
                ? "In Progress"
                : orderStatus === "PU"
                ? "Picked Up"
                : "Delivered"}
            </Tag>
          </span>
        ),
      },
    ];

    return (
      <Row
        style={{
          marginTop: "2%",
          marginBottom: "2%",
          marginRight: "5%",
          marginLeft: "5%",
          width: "90%",
        }}
      >
        <Col xl={24} xs={24} sm={24} md={24} lg={24}>
          <h1 style={{ color: "#000000" }}>
            Hi, {userDetails && userDetails.firstName}
          </h1>
          <h3 style={{ color: "#587B98" }}>
            {window.location.pathname === "/app/driver/done"
              ? "Total delivered loads " + driversLeadsList.length
              : "You have " + driversLeadsList.length + " loads for today."}
          </h3>
        </Col>
        <Col xl={24} xs={24} sm={24} md={24} lg={24}>
          <Card bodyStyle={{ padding: "0px" }} className="card-padding">
            <Col
              xl={{ span: 8 }}
              lg={{ span: 8 }}
              md={{ span: 8 }}
              xs={{ span: 11 }}
              sm={{ span: 11 }}
              style={{ marginBottom: "1vw" }}
            >
              <Search
                className="products-search"
                size="large"
                placeholder="Search"
                onChange={(event) => this.searchData(event)}
              />
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} style={{ overflow: "auto" }}>
              <Table
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={driversLeadsList}
                loading={dataLoading}
                rowKey={(record) => record.id}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  total: driversLeadsList.length,
                  showTotal: showTotal,
                }}
                onRow={(r) => ({
                  onClick: () =>
                    window.location.pathname === "/app/driver/done"
                      ? (window.location = "/app/driver/done/" + r.id)
                      : (window.location = "/app/driver/todo/" + r.id),
                  style: { cursor: "pointer" },
                })}
              />
            </Col>
          </Card>
        </Col>
      </Row>
    );
  }
}
export default withAppContext(withRouter(DriverInfo));
